export const SEARCH_ZIPCODE_ACTIVATION = "SEARCH_ZIPCODE_ACTIVATION";
export const SEARCH_ZIPCODE_ACTIVATION_SUCCESSFULL = "SEARCH_ZIPCODE_ACTIVATION_SUCCESSFULL";
export const SEARCH_ZIPCODE_ACTIVATION_FAILED = "SEARCH_ZIPCODE_ACTIVATION_FAILED";
export const UPDATE_ZIPCODE_ACTIVATION="UPDATE_ZIPCODE_ACTIVATION";
export const UPDATE_ZIPCODE_ACTIVATION_SUCCESSFULL="UPDATE_ZIPCODE_ACTIVATION_SUCCESSFULL";